export default "__VITE_ASSET__u2gOy8f5__"